<template>
  <div>
    <nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <!-- LOGO EN DESKTOP -->
        <router-link :to="{name: 'inicio'}" class="navbar-item is-hidden-mobile" @click.native="showNavBurger = false">
          <img src="@/assets/img/logo.png" />
        </router-link>
        <!-- LOGO EN MOBILE -->
        <router-link :to="{name: 'inicio'}" class="navbar-item is-hidden-tablet" @click.native="showNavBurger = false">
          <img src="@/assets/img/logo-small.png" />
        </router-link>
        <!-- DROPDOWN PRODUCTOS SOLO MOBILE -->
        <a class="navbar-item is-hidden-desktop" href="#" @click="lanzarModalSelectorProducto">
          <button class="button">
            <span>Productos</span>
            <b-icon icon="menu-down"></b-icon>
          </button>
        </a>
        <!-- MENU PEDIDOS USUARIO MOBILE
        <b-dropdown v-if="userLogged" class="navbar-item is-hidden-tablet" aria-role="list">
          <button class="button" slot="trigger">
            <span>Panel</span>
            <b-icon icon="menu-down"></b-icon>
          </button>

          <b-dropdown-item aria-role="listitem">
            <router-link
              :to="{name: 'usuario-pedidos'}"
              @click.native="showNavBurger = false"
              class="navbar-item"
            >Pedidos</router-link>
          </b-dropdown-item>
          <b-dropdown-item aria-role="listitem">
            <router-link
              :to="{name: 'perfil'}"
              @click.native="showNavBurger = false"
              class="navbar-item"
            >Mi Perfil</router-link>
          </b-dropdown-item>
        </b-dropdown>
        SUBIR FOTOS
        <a class="navbar-item is-hidden-tablet" href="#" @click="lanzarModalSelectorProducto">
          <button class="button">
            <b-icon icon="new-box" type="is-secundary"></b-icon>
            <span>Subir Fotos</span>
          </button>
        </a>-->
        <!-- FIN NAV BRAND Y MOBILE -->
        <button
          class="button boton-menu is-hidden-desktop is-secundary"
          @click="showNavBurger = !showNavBurger"
        >
          <b-icon icon="menu"></b-icon>
          <span>Menú</span>
        </button>
      </div>

      <div id="navbar-mundo" class="navbar-menu" :class="{ 'is-active': showNavBurger }">
        <div class="navbar-start">
          <router-link
            :to="{name: 'inicio'}"
            @click.native="showNavBurger = false"
            class="navbar-item"
          >Inicio</router-link>
          <a class="navbar-item" href="#" @click="lanzarModalSelectorProducto">Productos</a>
          <router-link
            :to="{name: 'subir-fotos'}"
            @click.native="showNavBurger = false"
            class="navbar-item"
          >
            <b-icon icon="new-box" type="is-secundary" class="is-hidden-touch"></b-icon>
            <span>Subir Fotos</span>
          </router-link>

          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link">Ayuda</a>
            <div class="navbar-dropdown is-boxed">
              <router-link
                :to="{name: 'sucursal'}"
                @click.native="showNavBurger = false"
                class="navbar-item"
              >Sucursal</router-link>
              <router-link
                :to="{name: 'nosotros'}"
                @click.native="showNavBurger = false"
                class="navbar-item"
              >Nosotros</router-link>
              <router-link
                :to="{name: 'contacto'}"
                @click.native="showNavBurger = false"
                class="navbar-item"
              >Contacto</router-link>
            </div>
          </div>
          <div
            v-if="userLogged && jwtDecoded.roles.includes(this.$constantes.roles.ADMIN)"
            class="navbar-item has-dropdown is-hoverable"
          >
            <a class="navbar-link">Admin</a>
            <div class="navbar-dropdown is-boxed">
              <router-link
                :to="{name: 'admin-pedidos'}"
                @click.native="showNavBurger = false"
                class="navbar-item"
              >Pedidos</router-link>
            </div>
          </div>

          <div v-if="userLogged" class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link">Panel</a>
            <div class="navbar-dropdown is-boxed">
              <router-link
                :to="{name: 'usuario-pedidos'}"
                @click.native="showNavBurger = false"
                class="navbar-item"
              >Pedidos</router-link>
              <router-link
                :to="{name: 'perfil'}"
                @click.native="showNavBurger = false"
                class="navbar-item"
              >Mi Perfil</router-link>
            </div>
          </div>
        </div>

        <div class="navbar-end">
          <div class="navbar-item">
            <div v-if="!userLogged" class="buttons">
              <router-link
                :to="{name: 'register'}"
                @click.native="showNavBurger = !showNavBurger"
                class="button is-primary"
              >
                <b-icon icon="account-plus-outline"></b-icon>
                <span>
                  <strong>Registrarse</strong>
                </span>
              </router-link>
              <router-link
                :to="{name: 'login'}"
                @click.native="showNavBurger = !showNavBurger"
                class="button is-secundary"
              >
                <b-icon icon="login"></b-icon>
                <span>Iniciar Sesión</span>
              </router-link>
            </div>
            <div v-else class="buttons">
              <a class="button" @click="logout">
                <b-icon icon="exit-to-app"></b-icon>
                <span>Cerrar Sesión</span>
              </a>
              <router-link :to="{name: 'perfil'}" class="button is-primary">
                <b-icon icon="account"></b-icon>
                <span>
                  <strong>{{jwtDecoded.username}}</strong>
                </span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<style scoped lang="scss">
.nav {
  margin-top: 3rem;
}
.boton-menu {
  margin-left: auto;
  margin-right: 1rem;
  margin-top: .4rem;
  padding: 0rem;
  height: 2.5rem;
  width: 5rem;
}
</style>

<script>
import { mapState, mapMutations } from 'vuex'
// import SelectorTipoProducto from '@/components/SelectorTipoProducto'

export default {
  name: 'NavBar',
  data () {
    return {
      showNavBurger: false,
      menuMobilePanelActive: false
    }
  },
  methods: {
    ...mapMutations(['logoutUser']),
    logout () {
      var componenteVue = this
      this.showNavBurger = false

      this.$apiService.logout(function () {
        componenteVue.$buefy.toast.open({
          duration: 2000,
          message: 'Cerrando sesión, espere un momento',
          position: 'is-top',
          type: 'is-primary'
        })
        setTimeout(() => {
          componenteVue.logoutUser()
          componenteVue.$router.push({ name: 'inicio' })
        }, 2000)
      })
    },
    lanzarModalSelectorProducto () {
      this.showNavBurger = false
      // TODO: Volver para atras cuando activen la web
      // Redireccion temporal a subir-fotos
      this.$router.push({ name: 'subir-fotos' })
      // Se deja comentado hasta que vuelvan a activar la web
      // this.$buefy.modal.open({
      //   parent: this,
      //   component: SelectorTipoProducto,
      //   trapFocus: true
      // })
    }
  },
  computed: {
    ...mapState(['userLogged']),
    jwtDecoded () {
      return this.$VueJwtDecode.decode(localStorage.getItem('jwt'))
    }
  },
  mounted () {
    // Se encarga de mostrar en modo touch los submenues
    document.querySelectorAll('.navbar-link').forEach(function (navbarLink) {
      navbarLink.addEventListener('click', function () {
        navbarLink.nextElementSibling.classList.toggle('is-hidden-touch')
      })
    })
  }
}
</script>
